import React from "react";
import { Sparkles, Heart, Compass } from "lucide-react";
import Reveal from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";
import { useWaitlist } from "@/context/WaitlistContext";

const VALUES = [
  { icon: Compass, title: "Curious builders", text: "People who love figuring out how things could work better." },
  { icon: Heart, title: "User obsessed", text: "We start with real everyday problems, not features." },
  { icon: Sparkles, title: "AI-native", text: "Comfortable building with modern AI from day one." },
];

export default function Careers() {
  const { openWaitlist } = useWaitlist();
  return (
    <div data-testid="careers-page" className="pt-32">
      <section className="relative overflow-hidden py-12 md:py-20">
        <div className="mesh-bg">
          <div className="mesh-blob" style={{ width: 440, height: 440, background: "#B8E3D9", top: -80, left: -40 }} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Careers</p>
            <h1 className="mt-6 font-heading text-4xl font-light tracking-tighter text-[#4B2E5A] md:text-6xl">
              We're always looking for curious builders
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-[#4B2E5A]/70">
              We may not have a specific role posted right now — but if you're excited about simplifying everyday decisions with AI, we'd love to hear from you.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16">
        <div className="mx-auto max-w-5xl px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-3 md:gap-8">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="glass h-full rounded-[24px] p-8 text-center">
                  <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F5C86B]/25">
                    <v.icon className="h-7 w-7 text-[#4B2E5A]" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-medium text-[#4B2E5A]">{v.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#4B2E5A]/60">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="mt-12 text-center">
            <a
              href="mailto:naari.livingtech@gmail.com?subject=I'd love to build at Naari"
              data-testid="careers-apply-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#4B2E5A] px-8 py-4 text-sm font-medium text-[#FCFAF7] hover:bg-[#4B2E5A]/90"
            >
              Reach out to us
            </a>
          </Reveal>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
